import { useCountUp } from "../../lib/hooks";

type Stat = {
  num: number;
  display: string;
  label: string;
  sublabel?: string;
};

const STATS: Stat[] = [
  {
    num: 3500,
    display: "3,500",
    label: "Years of unbroken tradition",
  },
  {
    num: 155,
    display: "155",
    label: "Members of the network",
  },
  {
    num: 16,
    display: "16",
    label: "Countries",
  },
];

function StatItem({ stat }: { stat: Stat }) {
  const { ref, value } = useCountUp(stat.num, 1800);
  // Format with thousands separator, fall back to display string when target reached.
  const formatted = value === stat.num ? stat.display : value.toLocaleString("en-US");

  return (
    <div className="px-6 sm:px-8 md:px-10 first:pl-0 last:pr-0 py-2">
      <div className="flex items-baseline gap-2">
        <span ref={ref} className="font-display text-[clamp(2.25rem,4.4vw,3.4rem)] leading-none tabular tracking-[-0.02em]">
          {formatted}
        </span>
        <span className="font-display-italic text-[clamp(1.5rem,3vw,2.25rem)] leading-none" style={{ color: "var(--color-violet)" }}>
          +
        </span>
      </div>
      <div className="mt-3 font-grotesk text-[0.72rem] tracking-[0.18em] uppercase text-[var(--color-ink-mute)]">
        {stat.label}
      </div>
      {stat.sublabel && (
        <div className="mt-1 font-display-italic text-[0.95rem] text-[var(--color-ink-light)]">
          {stat.sublabel}
        </div>
      )}
    </div>
  );
}

export function Stats() {
  return (
    <section className="border-b border-[var(--color-rule)]">
      <div className="container-edit py-10 md:py-12">
        <div className="flex items-baseline gap-5 mb-7 md:mb-8">
          <span className="eyebrow whitespace-nowrap">At present</span>
          <hr className="rule flex-1" />
          <span className="font-display-italic text-[0.95rem] text-[var(--color-ink-mute)] hidden md:inline whitespace-nowrap">
            a small community within an ancient one
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[var(--color-rule)]">
          {STATS.map((s) => (
            <StatItem key={s.label} stat={s} />
          ))}
        </div>
      </div>
    </section>
  );
}
